import apiClient from "./apiClient";
import { equipmentCalendary } from "../types/equipmentCalendaryTypes";

export const getEquipmentCalendar = async (startDate?: string, finishDate?: string, projectId?: number): Promise<equipmentCalendary[]> => {
  try {
      const response = await apiClient.get('/EquipmentCalendar', {
          params: {
              ...(startDate && { startDate }),
              ...(finishDate && { finishDate }),
              ...(projectId && { projectId })
          }
      });
      return response.data;
  } catch (error) {
      console.error('Error al obtener el calendario de equipos:', error);
      throw new Error('Error al obtener el calendario de equipos.');
  }
};